import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

const API_URL = `https://apii.digically.in/api/faqs/`;

const authHeader = () => {
  const token = localStorage.getItem("access");
  return token
    ? { Authorization: `Bearer ${token}` }
    : {};
};

/* ================= FETCH FAQS ================= */
export const fetchFaqs = createAsyncThunk(
  "faqs/fetchFaqs",
  async (_, { rejectWithValue }) => {
    try {
      const res = await axios.get(API_URL, {
        headers: authHeader(), // optional if protected
      });
      return res.data.results; // paginated response
    } catch (error) {
      return rejectWithValue("Failed to fetch FAQs");
    }
  }
);

/* ================= CREATE FAQ ================= */
export const createFaq = createAsyncThunk(
  "faqs/createFaq",
  async (data, { rejectWithValue }) => {
    try {
      const res = await axios.post(API_URL, data, {
        headers: { 
          "Content-Type": "multipart/form-data",
          ...authHeader(), 
        },
      });
      return res.data;
    } catch (error) {
      return rejectWithValue("Failed to create FAQ");
    }
  }
);

/* ================= UPDATE FAQ ================= */
export const updateFaq = createAsyncThunk(
  "faqs/updateFaq",
  async ({ id, data }, { rejectWithValue }) => {
    try {
      const res = await axios.put(`${API_URL}${id}/`, data, {
        headers: { "Content-Type": "multipart/form-data",
          ...authHeader(), },
      });
      return res.data;
    } catch (error) {
      return rejectWithValue("Failed to update FAQ");
    }
  }
);

/* ================= DELETE FAQ ================= */
export const deleteFaq = createAsyncThunk(
  "faqs/deleteFaq",
  async (id, { rejectWithValue }) => {
    try {
      await axios.delete(`${API_URL}${id}/`, {
        headers: authHeader(),
      });
      return id;
    } catch (error) {
      return rejectWithValue("Failed to delete FAQ");
    }
  }
);

const faqSlice = createSlice({
  name: "faqs",
  initialState: {
    items: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder

      /* Fetch */
      .addCase(fetchFaqs.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchFaqs.fulfilled, (state, action) => {
        state.loading = false;
        state.items = action.payload;
      })
      .addCase(fetchFaqs.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      /* Create */
      .addCase(createFaq.fulfilled, (state, action) => {
        state.items.unshift(action.payload);
      })

      /* Update */
      .addCase(updateFaq.fulfilled, (state, action) => {
        const index = state.items.findIndex(
          (faq) => faq.id === action.payload.id
        );
        if (index !== -1) state.items[index] = action.payload;
      })

      /* Delete */
      .addCase(deleteFaq.fulfilled, (state, action) => {
        state.items = state.items.filter(
          (faq) => faq.id !== action.payload
        );
      });
  },
});

export default faqSlice.reducer;
